export const isObject = (x) => {
  return x != null && typeof x === 'object';
};

export const isString = (x) => {
  const val = Object.prototype.toString.call(x) === "[object String]"
  return val;
};

export const fetchConfig = (param) => {
  let configValue;
  const fetchParam = hasParams(param);

  if (fetchParam) {
    configValue = fetchParam[param];
  } else {
    const error = `${param} config value is not valid!`;
    throw error;
  }
  return configValue;
};

export const hasParams = (paramArray, missingParamArray) => {
  let paramObj = {};
  let paramList;

  if(isString(paramArray)) {
    paramList = [paramArray];
  } else {
    paramList = [...paramArray];
  };

  let hasValues = true;

  for (let param of paramList) {
    const paramValue = window.amplifyConfig[param];
    if (!window.amplifyConfig || !paramValue) {
      if (missingParamArray) missingParamArray.push(param);
      hasValues = false;
    } else {
      paramObj[param] = paramValue;
    }
  }
  if(hasValues) {
    return paramObj;
  } else {
    return false;
  }
};

export const generateLabel = (str, fragment) => {
  if (!fragment) fragment = '';
  let myStr = '';
  let toUpper = true;

  for (let i = 0; i<str.length;i++) {
    if (str[i] === '_')  {
      myStr += fragment;
      toUpper = true;
    } else {
      if (toUpper) {
        myStr += str[i].toUpperCase();
        toUpper = false;
      } else {
        myStr += str[i];
      }
    }
  }
  return myStr;
};

export const buildQueryParams = (queryParams = {}) => {
  let additionalQueryStringParams = '';
  for (const key of Object.keys(queryParams)) {
    additionalQueryStringParams += additionalQueryStringParams === '' ? '?' : '&';
    additionalQueryStringParams += `${key}=${queryParams[key]}`;
  }
  return additionalQueryStringParams;
};

// Patterns are applied by BigQuery's RE2, which lacks lookaround and backreferences.
// Named groups ARE supported, so the lookbehind probes must match (?<= and (?<! rather
// than any '(?<'.
const NEGATION_HINT = 'Match on what the name does start with, as an alternation such as '
  + '^(Wardsprings|iYotah).';

const RE2_UNSUPPORTED = [
  [/\(\?=/, 'lookahead, (?=...)', NEGATION_HINT],
  [/\(\?!/, 'negative lookahead, (?!...)', NEGATION_HINT],
  [/\(\?<=/, 'lookbehind, (?<=...)', NEGATION_HINT],
  [/\(\?<!/, 'negative lookbehind, (?<!...)', NEGATION_HINT],
  [/(^|[^\\])\\[1-9]/, 'a backreference, such as \\1', 'Write the repeated text out in full.'],
];

/** Description of the first RE2-unsupported construct, or null. */
export const unsupportedByRe2 = (pattern) => {
  if (!pattern) return null;
  for (const [probe, description, hint] of RE2_UNSUPPORTED) {
    if (probe.test(pattern)) return `BigQuery cannot use ${description}. ${hint}`;
  }
  return null;
};

// RE2 spellings JavaScript cannot parse: (?P<name>...) and flag groups like (?i), (?i:...).
// Rewritten so `new RegExp` can be used as a syntax check. The result is only parsed, never
// matched, so dropping flag groups is safe.
export const toJsParseable = (pattern) =>
  pattern
    .replace(/\(\?P</g, '(?<')
    .replace(/\(\?[imsU-]+:/g, '(?:')
    .replace(/\(\?[imsU-]+\)/g, '');

/** Whether the pattern parses as RE2. Use instead of a bare `new RegExp`. */
export const isValidRe2Syntax = (pattern) => {
  try {
    new RegExp(toJsParseable(pattern));
    return true;
  } catch (err) {
    return false;
  }
};

/** Full check for an RE2 pattern. Returns an error string, or null. */
export const validateRe2Pattern = (pattern) => {
  if (!pattern) return null;
  const unsupported = unsupportedByRe2(pattern);
  if (unsupported) return unsupported;
  return isValidRe2Syntax(pattern) ? null : 'Not a valid regular expression.';
};
